import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { Component, OnInit } from '@angular/core';
import BrowserHelper from 'src/app/helpers/browser-helper';
import { Project } from 'src/app/model/project/project';
import { BaseProject } from 'src/app/model/project/base-project';
import Product from 'src/app/model/product/product';
import { SnackService } from 'src/app/services/snack.service';
import { Router } from '@angular/router';
import ProjectHelper from 'src/app/helpers/project-helper';
import { ContactPickerEvent } from 'src/app/shared/contact-picker/contact-picker-event';
import { SubmitExecutedProjectControllerRequestService } from '../../../services/api/submit-executed-project/submit-executed-project-controller-request.service';

@Component({
  selector: 'create-old-system-project',
  templateUrl: './create-old-system-project.component.html',
  styleUrls: ['./create-old-system-project.component.scss'],
})
export class CreateOldSystemProjectComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  isCollapsedCompany: boolean = false;
  isCollapsedProject: boolean = true;
  isCollapsedPlacement: boolean = true;
  isHiddenProject: boolean = true;
  isHiddenPlacement: boolean = true;
  safari: boolean;

  project: Project;
  baseProject: BaseProject;

  showAddProduct: boolean = false;
  submitDisabled: boolean = false;

  constructor(
    private submitExecutedProjectService: SubmitExecutedProjectControllerRequestService,
    private snackService: SnackService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.safari = BrowserHelper.isSafari();
    this.project = new Project();
    this.baseProject = new BaseProject();
    this.project.subProjects = [this.baseProject];
    this.project.products = [new Product()];
    this.baseProject.withPlacement = true;
    this.baseProject.fromOldSystem = true;
  }

  scrollTo(element: HTMLElement) {
    window.scrollTo(0, element.offsetTop - 60);
  }

  collapseAllSections() {
    this.isCollapsedCompany = true;
    this.isCollapsedProject = true;
    this.isCollapsedPlacement = true;
  }

  expandCompany() {
    this.collapseAllSections();
    this.isCollapsedCompany = false;
  }

  expandProject() {
    this.collapseAllSections();
    this.isCollapsedProject = false;
  }

  expandPlacement() {
    this.collapseAllSections();
    this.isCollapsedPlacement = false;
  }

  setContacts(contactPickerEvent: ContactPickerEvent) {
    this.project.projectContacts = contactPickerEvent.projectContacts;
  }

  contactNext() {
    this.isHiddenProject = false;
    this.collapseAllSections();
    this.isCollapsedProject = false;
  }

  projectNext() {
    this.isHiddenPlacement = false;
    this.collapseAllSections();
    this.isCollapsedPlacement = false;
    window.scrollTo(0, 0);
  }

  productTypeWasSelected() {
    this.showAddProduct = true;
  }

  addProduct() {
    this.showAddProduct = false;
    let prod = new Product();
    this.project.products.push(prod);
  }

  submit() {
    this.submitDisabled = true;
    this.addSubscription(
      this.submitExecutedProjectService.submitExecutedProject(this.project),
      (result) => {
        if (result.success != null && result.success === false) {
          this.snackService.showError(result.message);
          this.submitDisabled = false;
        } else {
          this.snackService.showSuccess(
            'Uitgevoerd project succesvol aangemaakt'
          );
          const baseProject = ProjectHelper.getBaseProject(result);
          if (baseProject != null) {
            this.router.navigateByUrl(
              '/project/' + result.id + '/' + baseProject.id
            );
          } else {
            this.router.navigateByUrl('/projecten');
          }
        }
      },
      (err) => {
        this.snackService.showError(err);
        this.submitDisabled = false;
      }
    );
  }
}
